/**
 * Canonical Chat runtime schema version.
 * Must match `crates/athena-chat` `CHAT_RUNTIME_SCHEMA_VERSION`
 * and the `athena.runtime_schema_versions` row for `chat_runtime`.
 */
export const ATHENA_CHAT_RUNTIME_SCHEMA_VERSION = 4;

export const ATHENA_CHAT_RUNTIME_SCHEMA_COMPONENT = "chat_runtime";
